"use client";
import AwardAreaCard from "@/components/common/award-area-card";
import { awards } from "@/data/data";
import * as motion from "motion/react-client";

const AwardArea = () => {
    return (
        <>
            <section className="desilo-awards-area section-padding-top overflow-hidden portfolio-details__content">
                <div className="container custom-container">
                    <div className="row g-4 justify-content-between">
                        <div className="col-lg-4">
                            <h2 className="portfolio-details__title">
                                The Solutions
                            </h2>
                        </div>
                        <div className="col-lg-12 col-xl-10 col-xxl-6">
                            <div>
                                <h3>Finding uniqueness in a standard product and perfecting its implementation</h3>
                                <p className="portfolio-text">
                                    We provided a solution that not only streamlined sales planning and execution but also introduced a powerful feedback loop. This allowed Sales Mangers to evaluate Sales Representatives, providing data-driven insights for Directors to monitor and coach their teams more effectively.
                                </p>
                            </div>
                            {/* awards start  */}
                            {awards.map((item, i) => (
                                <motion.div
                                    initial={{ opacity: 0, y: 50 }}
                                    whileInView={{
                                        opacity: 1,
                                        y: 0,
                                        transition: {
                                            duration: 0.5,
                                            delay: i * 0.2,
                                        },
                                    }}
                                    viewport={{ once: true }}
                                    key={i}
                                    className="portfolio-text"
                                >
                                    <AwardAreaCard data={item} />
                                </motion.div>
                            ))}
                            {/* awards end  */}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default AwardArea;
